import { BreadcrumbHeading, CardGrid, MenuIcon, Plus, PrimaryButton, Spinner } from '@weareopenr/component-library';
import MenuModal from '../../components/MenuModal';
import { IMenu } from '../../types/menu.types';
import MenuCard from '../../components/MenuCard';
import EmptyState from '../../components/EmptyState';
import { SpinnerContainer } from 'src/components/SpinnerContainer';
import { useEffect, useState } from 'react';
import { useMenus } from '../../hooks/useMenus';
import { useUserTracking } from 'src/hooks/useUserTracking/useUserTracking';
import styles from './Menus.module.scss';

const Menus = () => {
  const { data: menus, isFetching: isMenusFetching } = useMenus();
  const [isMenuModalOpen, setIsMenuModalOpen] = useState<boolean>(false);
  const { trackEvent } = useUserTracking();

  useEffect(() => {
    document.title = 'Menus';
    trackEvent('page_viewed', { page: 'menus' });
  }, []);

  return (
    <>
      {isMenusFetching ? (
        <SpinnerContainer>
          <Spinner size="xlarge" colour="rainbow" />
        </SpinnerContainer>
      ) : (
        <>
          <div className={styles['header-container']}>
            <BreadcrumbHeading
              breadcrumbs={[{ label: 'Menus', path: '/menus' }]}
              primaryButton={
                <PrimaryButton onClick={() => setIsMenuModalOpen(true)} icon={Plus}>
                  Create menu
                </PrimaryButton>
              }
            />
          </div>
          <MenuModal
            title="Create new menu"
            closeModal={() => setIsMenuModalOpen(false)}
            open={isMenuModalOpen}
            variant="create"
            image={null}
          />
          {menus.length > 0 ? (
            <CardGrid>
              {menus.map((menu: IMenu) => {
                const { menuId: menuID, name, image, consumerName } = menu;
                return <MenuCard menuId={menuID} name={name} image={image} key={menuID} consumerName={consumerName} />;
              })}
            </CardGrid>
          ) : (
            <EmptyState
              emptySectionText="Add your first menu"
              onClick={() => setIsMenuModalOpen(true)}
              buttonText="Create menu"
              type="menu"
              Icon={MenuIcon}
            />
          )}
        </>
      )}
    </>
  );
};

export default Menus;
